export const columns = [
	{
		orderNumber: 1,
		label: 'Case Number',
		name: 'caseNumber',
		visible: true
	},
	{
		orderNumber: 2,
		label: 'Court',
		name: 'court',
		visible: true
	},
	{
		orderNumber: 3,
		label: 'Style',
		name: 'style',
		visible: true
	},
	{
		orderNumber: 4,
		label: 'Filing Date',
		name: 'filingDate',
		visible: true,
		type: 'date'
	},
	{
		orderNumber: 5,
		label: 'Category',
		name: 'category',
		visible: true
	},
	{
		orderNumber: 6,
		label: 'Offense/Case Type',
		name: 'offenseCaseType',
		visible: true
	},
	{
		orderNumber: 7,
		label: 'Disposition Date',
		name: 'dispositionDate',
		visible: true,
		type: 'date'
	},
	{
		orderNumber: 8,
		label: 'Case Status',
		name: 'caseStatus',
		visible: true
	},
	{
		orderNumber: 9,
		label: 'Warrant',
		name: 'warrant',
		visible: true
	},
	{
		orderNumber: 10,
		label: 'Parties',
		name: 'parties',
		visible: true
	},
	{
		orderNumber: 11,
		label: 'CA/DA Cause Number',
		name: 'cadaCauseNumber',
		visible: true
	},
	{
		orderNumber: 12,
		label: 'Offense Date',
		name: 'offenseDate',
		visible: true,
		type: 'date'
	},
	{
		orderNumber: 13,
		label: 'Date Of Birth',
		name: 'dateOfBirth',
		visible: true,
		type: 'date'
	},
	{
		orderNumber: 14,
		label: 'Defendant',
		name: 'defendant',
		visible: true
	},
	{
		orderNumber: 15,
		label: 'Alias',
		name: 'alias',
		visible: true
	},
	{
		orderNumber: 16,
		label: 'Amount Owed',
		name: 'amountOwed',
		visible: true
	}
];
